import { render } from "./StatsTab.vue?vue&type=template&id=ba23f30e&scoped=true"
import script from "./StatsTab.vue?vue&type=script&lang=js"
export * from "./StatsTab.vue?vue&type=script&lang=js"

import "./StatsTab.vue?vue&type=style&index=0&id=ba23f30e&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba23f30e"]])

export default __exports__